import { create } from 'zustand'

import { resolveTheme } from '../resolveTheme'

/**
 * The single owner of the active theme (MUI and the 3D graph read it). Read
 * synchronously at module init from `localStorage.background`, which every page
 * template seeds before the bundle runs; nothing may publish a placeholder theme
 * ahead of it (a bootstrap-store relay once did, and the page flipped mid-load).
 */
const getInitialTheme = () => {
    // `typeof window` alone is not a server check here: `flowdock-text` defines a global
    // `window` with no location/localStorage. Guard on what is actually read.
    if (typeof window === 'undefined') return 'light'
    if (!window.location || !window.localStorage) return 'light'
    return resolveTheme({
        urlBackground: new URLSearchParams(window.location.search).get(
            'background'
        ),
        storedBackground: localStorage.getItem('background'),
    })
}

const useBrowserTheme = create((set, get) => ({
    theme: getInitialTheme(),
    getTheme: () => {
        return get().theme
    },
    setTheme: theme => {
        let resolved
        if (theme) {
            resolved = theme
        } else {
            resolved = get().theme === 'dark' ? 'light' : 'dark'
        }
        set({ theme: resolved })
        // Keep localStorage.theme in sync so infranodus-graph reads the correct value
        if (typeof window !== 'undefined') {
            localStorage.setItem('theme', resolved)
        }
    },
}))
export default useBrowserTheme
